import { Article, CalendarMonth } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { VoyageFormField } from "./VoyageFormField";

export const VoyageDates = ({ dataState, setDataState }) => {
    const { t } = useTranslation();

    const matches11 = useMediaQuery("(min-width:970px)");

    return (
        <>
            <M_Fieldset
                labelInside
                label={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "25px",
                            marginLeft: "10px",
                        }}
                    >
                        <CalendarMonth
                            style={{ marginRight: "10px", scale: "1.3" }}
                        />{" "}
                        {t("Dates")}
                    </div>
                }
                elements={
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                    >
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: matches11 ? "1fr 1fr" : "1fr"
                        }}>
                            <VoyageFormField
                                label={t("ETA")}
                                type={dataState.IsView ? "disabledDate" : "date"}
                                code="VoyageDateETA"
                                data={dataState}
                                setData={setDataState}
                            />
                            <VoyageFormField
                                label={t("TimeETA")}
                                type={dataState.IsView ? "disabled" : "number"}
                                code="VoyageTimeETA"
                                data={dataState}
                                setData={setDataState}
                            />

                            <VoyageFormField
                                label={t("ETD")}
                                type={dataState.IsView ? "disabledDate" : "date"}
                                code="VoyageDateETD"
                                data={dataState}
                                setData={setDataState}
                            />
                            <VoyageFormField
                                label={t("TimeETD")}
                                type={dataState.IsView ? "disabled" : "number"}
                                code="VoyageTimeETD"
                                data={dataState}
                                setData={setDataState}
                            />

                            <VoyageFormField
                                label={t("RTA")}
                                type={dataState.IsView ? "disabledDate" : "date"}
                                code="VoyageDateRTA"
                                data={dataState}
                                setData={setDataState}
                            />
                            <VoyageFormField
                                label={t("TimeRTA")}
                                type={dataState.IsView ? "disabled" : "number"}
                                code="VoyageTimeRTA"
                                data={dataState}
                                setData={setDataState}
                            />
                            <VoyageFormField
                                label={t("RTD")}
                                type={dataState.IsView ? "disabledDate" : "date"}
                                code="VoyageDateRTD"
                                data={dataState}
                                setData={setDataState}
                            />
                            <VoyageFormField
                                label={t("TimeRTD")}
                                type={dataState.IsView ? "disabled" : "number"}
                                code="VoyageTimeRTD"
                                data={dataState}
                                setData={setDataState}
                            />
                        </div>

                        <VoyageFormField
                            label={t("StartETD")}
                            type={dataState.IsView ? "disabledDate" : "date"}
                            code="VoyageStartETD"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("PreviousETD")}
                            type={dataState.IsView ? "disabledDate" : "date"}
                            code="VoyagePreviousETD"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("NextETA")}
                            type={dataState.IsView ? "disabledDate" : "date"}
                            code="VoyageNextETA"
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                }
            />
        </>
    );
};
